import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの支払方法を更新する
 *
 * @param {Number} uid ユーザID
 * @param {Number} payid 支払方法ID
 * @param {Object} payment 支払方法情報
 * @returns {Response} レスポンスデータ
 */
export function putUserPayment (uid, payid, payment) {
  return request.put(`/users/${uid}/payments/${payid}`, payment, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
